import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: null,
    testerItems: [],
};

const testerManagementSlice = createSlice({
    name: 'testerer',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        gettesterSuccess(state, action) {
            state.isLoading = false;
            state.testerItems = action.payload;
        },
    },
});

export default testerManagementSlice.reducer;

export const { startLoading, hasError, gettesterSuccess } = testerManagementSlice.actions;

export const getAllTesterShipments = () => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.get('shipments/tester');
        dispatch(gettesterSuccess(response?.data?.data));
    } catch (error) {
        dispatch(hasError(error));
    }
};
